import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v1/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v1/tiled-model';

export class TiledModelServiceV1 implements types.Handlers {
  private serviceEndpoint = 'v1/tiled-models';

  constructor(private axios: AxiosInstance) {}

  async getSignedRequestParameters({
    path,
  }: types.GetSignedRequestParametersParameters): Promise<common.SignedRequestResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${path.tiledModelId}/signed-request`))
      .data;
  }

  async deleteTiledModel({ path }: types.DeleteTiledModelParameters): Promise<void> {
    await this.axios.delete(`${this.serviceEndpoint}/${path.tiledModelId}`);
  }

  async getTiledModel({
    path,
  }: types.GetSignedRequestParametersParameters): Promise<common.GetTiledModelResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${path.tiledModelId}`)).data;
  }
}
